import styled from 'styled-components'
import { useMemo } from 'react'
import Text from './shared/Text'
import {
	ArrowRight,
	FastCharge,
	RegularCharge,
	StallIcon,
	TeslaLogo,
} from '../utility/icons'
import styles from '../utility/styles'

const Wrapper = styled.button`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: ${({ selected, selectedPin }) =>
		selectedPin && !selected
			? 'var(--tz-surface, #0F131A)'
			: 'var(--tz-surface-raised, #1A202C)'};
	border: none;
	margin-bottom: 8px;
	padding: 0;
	border-radius: 8px;
	overflow: hidden;
	@media screen and ${styles.breakpoints.desktop} {
		width: calc(100vw - 72px);
		margin: 0 24px;
		height: 100%;
	}
`

const TitleText = styled(Text.Heading)`
	white-space: nowrap;
	text-overflow: ellipsis;
`

const Row = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
`
const Col = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: flex-start;
	padding: 18px 0 18px 18px;
	overflow: hidden;
	width: 100%;
`
const IconWrapper = styled.div`
	background-color: ${styles.colors.chargingGreen};
	display: flex;
	flex: 0;
	height: 100%;
	padding: 0 12px;
	align-items: center;
`
	

/**
 *
 * @param {{
 *   title:string,
 *   id:string,
 *   longitude:number,
 *   latitude:number,
 *   power:number,
 *   type:'150kW'|'250kW'
 *   stallsTotal:number,
 *   stallsAvailable:number
 *   onClick:(id:string,longitude:number,latitude:number)=>void,
 *   onHover:(id:string)=>void,
 *   selectedPin:string
 * }} props
 * @returns
 */
export default function MapListItem({
	title,
	subtitle,
	power,
	type = '150kW',
	stallsTotal,
	stallsAvailable,
	id,
	longitude,
	latitude,
	onClick,
	onHover,
	selectedPin
}) {

	const selected = useMemo(() => selectedPin === id, [id, selectedPin])
	const onHoverInternal = () => {
		if (typeof onHover === 'function')  onHover(id)
	}

	const onClickInternal = () => {
		if (typeof onClick === 'function') onClick(id, longitude, latitude)
	}

	return (
		<Wrapper
			{...{ selected, selectedPin }}
			onClick={onClickInternal}
			onMouseOver={onHoverInternal}
		>
			<IconWrapper>
				<TeslaLogo />
			</IconWrapper>
			<Col>
				<TitleText type='h5' variant='bold'>
					{title}
				</TitleText>
				<Text.Caption>{subtitle}</Text.Caption>
				<Row style={{ width: '100%', marginTop: '9px' }}>
					<Row>
						{type === '150kW' ? (
							<RegularCharge style={{ marginRight: '4px' }} />
						) : (
							<FastCharge style={{ marginRight: '4px' }} />
						)}
						<Text.Caption variant='bold'>{power}kW</Text.Caption>
					</Row>
					{!!stallsTotal && (
						<Row>
							<StallIcon />
							{!!stallsAvailable ? (
								<Text.Caption variant='bold'>
									{stallsAvailable}/{stallsTotal} Open
								</Text.Caption>
							) : (
								<Text.Caption variant='bold'>
									{stallsTotal} Stalls
								</Text.Caption>
							)}
						</Row>
					)}
				</Row>
			</Col>
			<ArrowRight style={{ marginRight: '16px' }} />
		</Wrapper>
	)
}
